import React from 'react';
import cn from 'classnames';

import useTooltip from 'hooks/common/useTooltip';

import styles from './Controls.module.scss';

function ControlButton(props) {
    const {
        value,
        changeValue,
        enabledIcon: EnabledIcon,
        disabledIcon: DisabledIcon,
        disableText,
        enableText,
        tooltipPosition = 'bottom',
        ...restProps
    } = props;
    const {tooltip, hoverFunctions} = useTooltip(
        value ? disableText : enableText,
        cn(styles.tooltip, restProps.tooltipClassName),
        {position: tooltipPosition}
    );
    return (
        <div className={styles.iconContainer}>
            {value ? (
                <EnabledIcon
                    onClick={() => changeValue(false)}
                    className={styles.icon}
                    {...restProps}
                    {...hoverFunctions}
                />
            ) : (
                <DisabledIcon
                    onClick={() => changeValue(true)}
                    className={styles.icon}
                    {...restProps}
                    {...hoverFunctions}
                />
            )}
            {tooltip}
        </div>
    );
}

export default React.memo(ControlButton);
